import React from 'react';
import { CircleProgress } from './CircleProgress';
import {
  CircleChartWrapper,
  StyledSVG,
  CenterText,
} from './ConcentricCircleChart.styled';

interface Props {
  scoreE: number | null;
  scoreS: number | null;
  scoreG: number | null;
  totalScore: number | null;
  isMapMarker?: boolean;
}

export const ConcentricCircleChart: React.FC<Props> = ({
  scoreE,
  scoreS,
  scoreG,
  totalScore,
  isMapMarker,
}) => {
  // Scale down the circles when there's no total score and it's used as a map marker
  const scale = totalScore !== null ? 1 : (isMapMarker ? 0.65 : 1);
  const outerRadius = 56 * scale;
  const middleRadius = 46 * scale;
  const innerRadius = 36 * scale;
  const strokeWidth = 6 * scale;
  const fontSize = 36 * scale;

  return (
    <CircleChartWrapper>
      <StyledSVG viewBox="0 0 120 120">
        <CircleProgress
          radius={outerRadius}
          strokeWidth={strokeWidth}
          percent={scoreE}
          scoreType="E"
        />
        <CircleProgress
          radius={middleRadius}
          strokeWidth={strokeWidth}
          percent={scoreS}
          scoreType="S"
        />
        <CircleProgress
          radius={innerRadius}
          strokeWidth={strokeWidth}
          percent={scoreG}
          scoreType="G"
        />
        <CenterText
          x="60"
          y="60"
          textAnchor="middle"
          dominantBaseline="central"
          transform="rotate(90, 60, 60)" //rotate the text wrt the center of the circle aligning it with the circles
          fontSize={fontSize}
          fontWeight="700"
          fill={(totalScore != null || !isMapMarker) ? 'var(--color-black)' : 'var(--color-gray-300)'}
        >
          {totalScore ?? 'NA'}
        </CenterText>
      </StyledSVG>
    </CircleChartWrapper>
  );
};
